import React from "react";
import PropTypes from 'prop-types';

export default class CRMSearchHeader extends React.Component {

    static propTypes = {
        type: PropTypes.oneOf(['remove-contact', 'contact', 'account']),
        search: PropTypes.string,

        onSearchChange: PropTypes.func,
        onSearchCancel: PropTypes.func,
        onCloseModal: PropTypes.func,
    }

    focusInput = () => {if(this.input) this.input.focus()}

    getLabels() {
        let title, placeholder;
        switch (this.props.type) {
            case 'remove-contact'   :
            case 'contact'          : title = 'Select contact'; placeholder = 'Search contact'; break;
            case 'account'          : title = 'Select company'; placeholder = 'Search company'; break;
        }
        return {title, placeholder}
    }

    render() {
        const {title, placeholder} = this.getLabels();

        return (
            <div className="header crm-header">
                <div className="title">{title}</div>
                <div className="search">
                    <input ref={r=>this.input = r} className="gd-input big" type="input" placeholder={placeholder} value={this.props.search} onChange={this.props.onSearchChange}/>
                    <div className="i5-search"/>
                    {!!this.props.search && <div className="i5-delete" onClick={this.props.onSearchCancel}/>}
                </div>

                <div className="i5-delete" onClick={this.props.onCloseModal}/>
            </div>
        )
    }
}